import styles from "@/overlay/components/QuickAccessLabel/LabelTitle.module.scss";
import { convertToCSSProperties } from "@/utility/style";
import type { ElementStyle } from "@mm/metx-workbench.meteomatics.com";

export function OffsetDescription(props: {
  titleStyle?: ElementStyle;
  onClick?: () => void;
  offsetMinutes?: number;
  disabled?: boolean;
}) {
  const { offsetMinutes, onClick, titleStyle, disabled } = props;
  if (!offsetMinutes) {
    return <></>;
  }

  const symbol = offsetMinutes > 0 ? "+" : "-";
  const unit = offsetMinutes % 60 === 0 ? "h" : "m";

  const displayNumber = offsetMinutes % 60 === 0 ? offsetMinutes / 60 : offsetMinutes;

  return (
    <>
      <span
        className="material-icons"
        style={{ fontSize: titleStyle?.fontSize || "1rem", ...(disabled ? { pointerEvents: "none" } : {}) }}
      >
        more_time
      </span>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
      <span
        data-testid="datetime-label-formatted"
        className={styles["formatted-datetime"]}
        onClick={onClick}
        style={{ ...convertToCSSProperties(titleStyle), ...(disabled ? { pointerEvents: "none" } : {}) }}
      >
        {symbol}
        {Math.abs(displayNumber)}
        {unit}
      </span>
    </>
  );
}
